module.exports = __webpack_public_path__ + "img/2x.fc313d8.jpg";